<template>
  <div class="goods-edit-form">
    <div class="goods-edit-form__header">
      <h2>Редактировать товар</h2>
    </div>

    <form @submit.prevent="submitForm" class="goods-edit-form__content">
      <div class="goods-edit-form__formRow">
        <div class="goods-edit-form__formGroup">
          <label for="displayName">Название товара (display_name) *</label>
          <input
            id="displayName"
            type="text"
            v-model="formData.display_name"
            placeholder="Введите название товара"
            required
            :class="{ error: errors.display_name }"
          />
          <span v-if="errors.display_name" class="goods-edit-form__error">
            {{ errors.display_name }}
          </span>
        </div>

        <div class="goods-edit-form__formGroup">
          <label for="originalName">Оригинальное название (original_name) *</label>
          <input
            id="originalName"
            type="text"
            v-model="formData.original_name"
            placeholder="Введите оригинальное название"
            required
            :class="{ error: errors.original_name }"
          />
          <span v-if="errors.original_name" class="goods-edit-form__error">
            {{ errors.original_name }}
          </span>
        </div>
      </div>

      <div class="goods-edit-form__formGroup">
        <label for="originalName">Название в игре (game_name) *</label>
        <input
          id="originalName"
          type="text"
          v-model="formData.game_name"
          placeholder="Введите оригинальное название"
          required
          :class="{ error: errors.game_name }"
        />
        <span v-if="errors.game_name" class="goods-edit-form__error">
          {{ errors.game_name }}
        </span>
      </div>

      <div class="goods-edit-form__formGroup">
        <label for="description">Описание</label>
        <div class="goods-edit-form__descriptionSelect">
          <button
            type="button"
            class="goods-edit-form__descriptionBtn"
            @click="openDescriptionSelector"
            :class="{ error: errors.description_id }"
          >
            <span v-if="selectedDescription">
              {{ selectedDescription.name }} ({{ selectedDescription.id }})
            </span>
            <span v-else>Выберите описание</span>
            <img src="../../assets/images/down-arrow.svg" alt="select" />
          </button>
          <button
            v-if="selectedDescription"
            type="button"
            class="goods-edit-form__removeDescription"
            @click="removeDescription"
          >
            <img src="../../assets/images/close.svg" alt="remove" />
          </button>
        </div>
        <span v-if="errors.description_id" class="goods-edit-form__error">
          {{ errors.description_id }}
        </span>
      </div>

      <div class="goods-edit-form__formGroup">
        <label for="image">Изображение *</label>
        <div class="goods-edit-form__imageUpload">
          <input
            id="image"
            type="file"
            ref="fileInput"
            @change="handleFileSelect"
            accept="image/*"
            style="display: none"
          />
          <button
            type="button"
            class="goods-edit-form__uploadBtn"
            @click="$refs.fileInput.click()"
            :class="{ error: errors.image }"
          >
            <img src="../../assets/images/upload.svg" alt="upload" />
            <span>{{ formData.image ? 'Изменить изображение' : 'Выберите изображение' }}</span>
          </button>
          <div v-if="imagePreview" class="goods-edit-form__imagePreview">
            <img :src="imagePreview" alt="preview" />
            <button
              type="button"
              class="goods-edit-form__removeImage"
              @click="removeImage"
            >
              <img src="../../assets/images/close.svg" alt="remove" />
            </button>
          </div>
        </div>
        <span v-if="errors.image" class="goods-edit-form__error">
          {{ errors.image }}
        </span>
      </div>

      <div class="goods-edit-form__formGroup">
        <label for="status">Статус *</label>
        <select
          id="status"
          v-model="formData.status"
          :class="{ error: errors.status }"
        >
          <option value="0">Неактивный</option>
          <option value="10">Активный</option>
        </select>
        <span v-if="errors.status" class="goods-edit-form__error">
          {{ errors.status }}
        </span>
      </div>

      <div class="goods-edit-form__formActions">
        <button type="submit" class="goods-edit-form__submitBtn" :disabled="loading || !hasChanges">
          <span v-if="loading">Сохранение...</span>
          <span v-else>Сохранить изменения</span>
        </button>
        <button type="button" class="goods-edit-form__cancelBtn" @click="cancel">
          Отмена
        </button>
      </div>

      <div v-if="generalError" class="goods-edit-form__generalError">
        {{ generalError }}
      </div>
    </form>

    <description-selector
      :isOpen="showDescriptionSelector"
      :selectedGame="selectedGame"
      :currentDescriptionId="formData.description_id"
      @select="onDescriptionSelect"
      @close="closeDescriptionSelector"
    />
  </div>
</template>

<script>
import DescriptionSelector from '../DescriptionSelector/DescriptionSelector.vue'
import { getGoodImageUrl } from '@/apis'

export default {
  name: 'GoodsEditForm',
  components: {
    DescriptionSelector
  },
  props: {
    selectedGame: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    goodData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        display_name: '',
        original_name: '',
        game_name: '',
        image: null,
        description_id: null,
        status: 0
      },
      originalData: {
        display_name: '',
        original_name: '',
        game_name: '',
        description_id: null,
        status: 0
      },
      imagePreview: null,
      selectedDescription: null,
      showDescriptionSelector: false,
      errors: {},
      generalError: ''
    }
  },
  mounted() {
    this.initializeForm()
  },
  methods: {
    initializeForm() {
      this.formData = {
        display_name: this.goodData.display_name || '',
        original_name: this.goodData.original_name || '',
        game_name: this.goodData.game_name || '',
        image: null,
        description_id: this.goodData.description_id || null,
        status: this.goodData.status || 0
      }
      
      this.originalData = {
        display_name: this.goodData.display_name || '',
        original_name: this.goodData.original_name || '',
        game_name: this.goodData.game_name || '',
        description_id: this.goodData.description_id || null,
        status: this.goodData.status || 0
      }
      
      // Устанавливаем превью изображения из существующих данных
      if (this.goodData.image_id) {
        this.imagePreview = getGoodImageUrl(this.goodData.image_id, this.goodData.game)
      }
    },
    handleFileSelect(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          this.errors.image = 'Размер файла не должен превышать 5MB'
          return
        }

        if (!file.type.startsWith('image/')) {
          this.errors.image = 'Выберите файл изображения'
          return
        }

        this.errors.image = ''

        const reader = new FileReader()
        reader.onload = (e) => {
          this.imagePreview = e.target.result
          this.formData.image = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    removeImage() {
      this.formData.image = null
      this.imagePreview = null
      this.errors.image = ''
      this.$refs.fileInput.value = ''
    },
    openDescriptionSelector() {
      this.showDescriptionSelector = true
    },
    closeDescriptionSelector() {
      this.showDescriptionSelector = false
    },
    onDescriptionSelect(description) {
      this.selectedDescription = description
      this.formData.description_id = description.id
      this.errors.description_id = ''
    },
    removeDescription() {
      this.selectedDescription = null
      this.formData.description_id = null
      this.errors.description_id = ''
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      if (!this.formData.display_name.trim()) {
        this.errors.display_name = 'Название товара обязательно'
        isValid = false
      }

      if (!this.formData.original_name.trim()) {
        this.errors.original_name = 'Оригинальное название обязательно'
        isValid = false
      }

      if (!this.formData.game_name.trim()) {
        this.errors.original_name = 'Игровое название обязательно'
        isValid = false
      }

      if (!this.formData.image && !this.goodData.image_id) {
        this.errors.image = 'Изображение обязательно'
        isValid = false
      }

      return isValid
    },
    submitForm() {
      this.generalError = ''
      
      if (!this.validateForm()) {
        return
      }

      const requestData = {}

      // Проверяем, какие поля изменились
      if (this.formData.display_name !== this.originalData.display_name) {
        requestData.display_name = this.formData.display_name
      }

      if (this.formData.original_name !== this.originalData.original_name) {
        requestData.original_name = this.formData.original_name
      }

      if (this.formData.game_name !== this.originalData.game_name) {
        requestData.game_name = this.formData.game_name
      }

      if (this.formData.status !== this.originalData.status) {
        requestData.status = parseInt(this.formData.status)
      }

      if (this.formData.description_id !== this.originalData.description_id) {
        requestData.description_id = this.formData.description_id
      }

      // Если изображение было изменено, добавляем его в запрос
      if (this.formData.image) {
        requestData.image = this.formData.image
      }

      // Если нет изменений, показываем сообщение
      if (Object.keys(requestData).length === 0) {
        this.generalError = 'Нет изменений для сохранения'
        return
      }

      this.$emit('submit', requestData)
    },
    cancel() {
      this.$emit('cancel')
    }
  },
  watch: {
    generalError(newError) {
      if (newError) {
        this.generalError = newError
      }
    },
    goodData: {
      handler() {
        this.initializeForm()
      },
      deep: true
    }
  },
  computed: {
    hasChanges() {
      return this.formData.display_name !== this.originalData.display_name ||
             this.formData.original_name !== this.originalData.original_name ||
             this.formData.status !== this.originalData.status ||
             this.formData.description_id !== this.originalData.description_id ||
             this.formData.image !== null
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-edit-form {
  background: #131732;
  border-radius: 8px;
  padding: 30px;
  border: 1px solid #646464;

  &__header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #2a2f4e;

    h2 {
      color: white;
      font-size: 24px;
      font-weight: 600;
      margin: 0;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  &__formRow {
    display: flex;
    gap: 20px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 25px;
    }

    .goods-edit-form__formGroup {
      flex: 1;
    }
  }

  &__formGroup {
    display: flex;
    flex-direction: column;
    gap: 12px;

    label {
      color: white;
      font-size: 16px;
      font-weight: 600;
    }

    input[type="text"], select {
      background: #1a1f3e;
      border: 1px solid #646464;
      border-radius: 6px;
      padding: 12px 16px;
      color: white;
      font-size: 14px;
      font-family: Gilroy, sans-serif;
      transition: all 0.3s ease;

      &:focus {
        outline: none;
        border-color: #7457ff;
      }

      &::placeholder {
        color: #888;
      }

      &.error {
        border-color: #ff4757;
      }
    }

    select {
      cursor: pointer;
    }
  }

  &__descriptionSelect {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__descriptionBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1a1f3e;
    border: 1px solid #646464;
    border-radius: 6px;
    padding: 12px 16px;
    color: white;
    font-size: 14px;
    font-family: Gilroy, sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
    text-align: left;

    &:hover {
      border-color: #7457ff;
    }

    &.error {
      border-color: #ff4757;
    }

    img {
      width: 16px;
      height: 16px;
      filter: brightness(0) invert(0.6);
      transition: 0.3s;
    }
  }

  &__removeDescription {
    background: #ff4757;
    border: none;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    img {
      width: 12px;
      height: 12px;
      filter: brightness(0) invert(1);
    }

    &:hover {
      background: #ff3742;
    }
  }

  &__imageUpload {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__uploadBtn {
    display: flex;
    align-items: center;
    gap: 12px;
    border: 2px dashed #646464;
    background: none;
    color: #888;
    padding: 20px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
      filter: brightness(0) invert(0.5);
      stroke: currentColor;
    }

    &:hover {
      border-color: #7457ff;
      color: #7457ff;

      img {
        filter: brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(240deg);
      }
    }

    &.error {
      border-color: #ff4757;
      color: #ff4757;
    }
  }

  &__imagePreview {
    position: relative;
    display: inline-block;
    max-width: 200px;

    img {
      width: 100%;
      height: auto;
      border-radius: 6px;
      border: 1px solid #2a2f4e;
    }
  }

  &__removeImage {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #ff4757;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    img {
      width: 12px;
      height: 12px;
      filter: brightness(0) invert(1);
    }

    &:hover {
      background: #ff3742;
    }
  }

  &__formActions {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid #2a2f4e;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  &__submitBtn {
    border: none;
    outline: none;
    border-radius: 6px;
    padding: 12px 24px;
    background: #7457ff;
    color: white;
    font-size: 15px;
    font-weight: 600;
    font-family: Gilroy, sans-serif;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
      background: #6a4fd8;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  &__cancelBtn {
    border: none;
    outline: none;
    border-radius: 6px;
    padding: 12px 24px;
    background: #1a1f3e;
    color: white;
    font-size: 15px;
    font-weight: 600;
    font-family: Gilroy, sans-serif;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #646464;

    &:hover {
      background: #2a2f4e;
    }
  }

  &__error {
    color: #ff4757;
    font-size: 13px;
    font-weight: 500;
  }

  &__generalError {
    background: #2d1b1b;
    border: 1px solid #ff4757;
    border-radius: 6px;
    padding: 12px 16px;
    color: #ff4757;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }
}
</style>
